import { Col, Row, Tooltip } from "antd";
import { FC } from "react";
import { useHandleDismissAlert } from "../../../../hooks/useHandleGlobalAlert";
import ActionModal from "../../ActionModal";
import { G_Button } from "../../Button";
import G_Div from "../../Containers/G_Div";
import G_Image from "../../Image/G_Image";
import { G_Text } from "../../Text";

interface Props {
  title: string;
  action: () => void;
  actionLabel: string;
  isLoading: boolean;
}

/**
 * @since February 2024
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 * @returns {JSX.Element | null}
 */

const G_GlobalAlert: FC<Props> = ({
  title,
  action = () => null,
  actionLabel,
  isLoading
}): JSX.Element | null => {
  const {
    handleShowDismissModal,
    isDismissModalVisible,
    setIsDismissModalVisible,
    handleDismissAlerts,
    areAlertsPaused
  } = useHandleDismissAlert();

  return !areAlertsPaused ? (
    <>
      <ActionModal
        loading={false}
        isModalVisible={isDismissModalVisible}
        setIsModalVisible={setIsDismissModalVisible}
        action={handleDismissAlerts}
        type="danger"
        actionLabel="PAUSE"
        description="By clicking `PAUSE`, you won't receive any alerts for 7 days. You can resume receiving alerts in settings."
        title="PAUSE ALERTS FOR 7 DAYS"
      />

      <Row className="bg_white_yellow w-full py-2 p-8" justify="space-between">
        <Col className="flex items-center">
          <Row gutter={24} align="middle">
            <Col>
              <G_Image src="/icons/alert-icon.svg" width={24} height={24} />
            </Col>

            <Col>
              <G_Text>{title}</G_Text>
            </Col>
          </Row>
        </Col>

        {/* Actions */}
        <Col className="flex items-center">
          <Row align="middle" gutter={12}>
            <Col>
              <G_Button
                bg="ox_2_transparent"
                isDynamic
                loading={isLoading}
                color="ox_2_primary"
                weight="normal"
                onClick={action}
                uppercase
              >
                {isLoading ? "Loading" : actionLabel}
              </G_Button>
            </Col>

            <Col>
              <Tooltip placement="bottom" title="Pause alerts">
                <G_Div>
                  <G_Button
                    iconSrc="/icons/close_black_24dp.svg"
                    isDynamic
                    type="default"
                    borderColor="ox_2_transparent"
                    onClick={handleShowDismissModal}
                    pointer
                  />
                </G_Div>
              </Tooltip>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  ) : null;
};

export default G_GlobalAlert;
